import { render, staticRenderFns } from "./sunhaoForm.vue?vue&type=template&id=24baa0ca&scoped=true&"
import script from "./sunhaoForm.vue?vue&type=script&lang=js&"
export * from "./sunhaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24baa0ca",
  null
  
)

export default component.exports